import {
  GOT_POP_VIDEOS,
  GOT_CHANNELS,
  GOT_HOME_VIDEOS,
  GETTING_POP_VIDEOS,
  GETTING_HOME_VIDEOS
} from "./actionTypes";
import changeKey from "./keyAction";
import yangAxios from "../YangAxios";

export const getChannels = code => {
  return async (dispatch, getState) => {
    const keys = getState().apiKey.keys;
    let index = getState().apiKey.currentKey;
    try {
      let res = await yangAxios.get(
        `videoCategories?part=
          snippet&regionCode=${code}&maxResults=8&key=${keys[index]}`
      );
      res = res.data;
      dispatch(gotPopChannels(res));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        dispatch(changeKey(index + 1));
        dispatch(getChannels(code));
      }
    }
  };
};

const gotPopChannels = data => ({
  type: GOT_CHANNELS,
  payload: data
});

export const getPopVideos = code => {
  return async (dispatch, getState) => {
    dispatch(gettingPopVideos(true));
    const keys = getState().apiKey.keys;
    let index = getState().apiKey.currentKey;
    try {
      let res = await yangAxios.get(
        `videos?part=${encodeURI(
          "snippet,contentDetails,statistics"
        )}&chart=mostPopular&regionCode=${code}&maxResults=8&key=${keys[index]}`
      );
      res = res.data;
      dispatch(gotPopVideos(res));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        dispatch(changeKey(index + 1));
        dispatch(getPopVideos(code));
      }
    }
    dispatch(gettingPopVideos(false));
  };
};

const gettingPopVideos = val => {
  return {
    type: GETTING_POP_VIDEOS,
    payload: val
  };
};

const gotPopVideos = data => {
  return {
    type: GOT_POP_VIDEOS,
    payload: data
  };
};

export const getHomeVideos = (id, title) => {
  return async (dispatch, getStore) => {
    dispatch(gettingHomeVideos(true, title));
    const keys = getStore().apiKey.keys;
    const index = getStore().apiKey.currentKey;
    const code = getStore().regionCode;
    try {
      let res = await yangAxios.get(
        `videos?part=${encodeURI(
          "snippet,contentDetails,statistics"
        )}&maxResults=8&videoCategoryId=${id}&chart=mostPopular&regionCode=${code}&key=${
          keys[index]
        }`
      );
      res = res.data;
      dispatch(gotHomeVideos(res, id));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        dispatch(changeKey(index + 1));
        dispatch(getHomeVideos(id, title));
      }
    }
    dispatch(gettingHomeVideos(false, title));
  };
};
const gettingHomeVideos = (val, title) => {
  return {
    type: GETTING_HOME_VIDEOS,
    payload: { val, title }
  };
};
const gotHomeVideos = (data, id) => {
  return {
    type: GOT_HOME_VIDEOS,
    payload: { data, id }
  };
};
